export default {
    /* branding */
    brand: '#F1F1F1',
    sidenavForeground: '#121314',
    sidenavColor: '#121314',
    sidenavActiveColor: '#FFFFFF',
    sidenavActiveBackground: '#1B1D20',
    subNavBackground: '#E9E9E9',
    /* branding - Team Related */
    homeScreenBanner: '#ffffff',
    bannerLinkText: '#3478F7',
    teamPicker: '#ffffff',
    teamPickerText: '#1e1e1f',

    /* Buttons */
    primaryAction: '#3478F7',
    primaryActionHover: '#005bbe',

    warningAction: '#FF2D55',
    warningActionHover: '#E00C35',

    secondaryTextAction: '#FF2D55',
    secondaryTextActionHover: '#E00C35',
    warningTextAction: '#007AFF',
    warningTextActionHover: '#005BBE',
    alertWarning: '#663C00',

    disabledAction: '#e6e5e3',
    inactiveAction: '#DBDBDB',

    /* Icons */
    defaultIconColor: '#576cf4',

    primaryDisplayIcon: '#1d1d1f',
    invertedDisplayIcon: '#ffffff',

    protipsIcon: '#ffcc00',
    protipsBubble: '#f5b11e',

    tilePinIcon: '#c7c6c5',

    amenitiesIconBackground: '#ffffff',

    /* Attendee Status */
    totalAttendee: '#2c2c2c',
    invitedAttendee: '#AC7607',
    notInvitedAttendee: '#909090',
    attendingAttendee: '#3A7249',
    notAttendingAttendee: '#BA4A41',
    roomBlocks: '#005BBE',
    totalPrice: '#177840',

    /* Attendee Status v2 */
    notAttendingAttendeeV2: '#BB0F23',
    attendingAttendeeV2: '#29733D',

    /* Survey Response Status */
    surveysSentTotal: '#000000',
    surveysPending: '#AC7607',
    surveysRespondedTo: '#3A7249',

    /* Event Status */
    uneditedEvent: '#006997',
    activeEvent: '#006997',
    activeEventHover: '#005A83',
    completedEvent: '#3A7249',
    completedEventHover: '#30633F',

    /* Dashboard */
    dashboardCard: '#f2f2f2',
    dashboardHeader: '#1d1d1f',

    /* Parcel Status */
    parcelInvite: '#72919D',
    parcelInviteHover: '#5c7985',
    parcelInviteSent: '#3A7249',
    parcelInviteSentHover: '#30633F',

    parcelNote: '#5856D6',
    parcelNoteHover: '#3F3DB2',
    parcelNoteSent: '#504165',
    parcelNoteSentHover: '#46415B',

    /* Inquiry Status */
    submittedInquiryStatus: '#3A7249',
    receivedProposalStatus: '#AC7607',
    cancelledOrRejectedStatus: '#BA4A41',
    contractPendingStatus: '#AC7607',
    bookedVenueStatus: '#504165',
    queuedVenueStatus: '#6B7280',

    /* Collaborators */
    canViewPillBackground: '#5856D6', // waiting
    canViewPillText: '#ffffff', // waiting
    canEditPillBackground: '#0582ee', // waiting
    officePillColor: '#0582ee',
    teamTemplatePill: '#0582ee',
    teamPreferenceNotesHeader: '#6A2BA6',

    /*
        Venues
    */

    /* Venue Search */
    venueSearchToken: '#909090',
    venueSearchTokenHover: '#787878',

    /* Venue Map Pins */
    venuePinOffice: '#0582ee',
    venuePinHighlight: '#005bbe',
    venuePinDining: '#ff5959',
    venuePinHotel: '#fccd5f',
    venuePinActivityUnique: '#00cc87',
    venuePinMuseumTheater: '#8884d8',
    venuePinEventMeetingConference: '#ed9a09',
    venuePinWorkspace: '#6236a3',
    venuePinSearchLocation: '#000000',
    venuePinTesting: '#6236a3',

    /* Venue Space OR Listing */
    featuredVenueOrSpaceName: '#ffffff',

    tagColor: '#909090',
    restaurantTagColor: '#909090',

    venueListingHeaders: '#1d1d1f',

    preferenceNotesHighlightedText: '#1d1d1f',

    displayPricing: '#3A7249',

    /* Forms */
    formLabel: '#1d1d1f',
    formHeading: '#1d1d1f',
    optionalSpecifier: '#909090',

    /* Panes */
    agendaDayPane: '#4a4a4a',
    agendaDayPaneText: '#ffffff',
    paneListItemBackground: '#f2f2f2',
    paneInsideListItemBackground: '#ffffff',

    /* snackbars */
    snackbarSuccess: '#3A7249',
    snackbarError: '#BA4A41',
    snackbarInfo: '#AC7607',

    /* dropdowns */
    dropdownCheck: '#007aff',
    dropdownItem: '#ffffff',
    dropdownItemHover: '#f2f2f2',
    dropdownDescription: '#909090',
    dropdownTokenBackground: '#f2f2f2',
    dropdownTokenText: '#1d1d1f',

    /* progress bars */
    progressBarForeground: '#3A7249',
    progressBarBackground: '#e5e5e3',

    /* misc ui */
    accentedHeadline: '#1d1d1f',
    highlightedText: '#1d1d1f',

    softAccentedBackground: '#f5f5f5',
    softAccentedBackgroundNested: '#ffffff',
    strongAccentedBackground: '#1d1d1f',

    warningBackground: '#BA4A41',
    warningText: '#BA4A41',

    bizlyHeadlineDot: '#04c6bc',

    placeholderBackground: '#f2f2f2',
    strongCarouselBackground: '#f2f2f2', //loading is a darker shade;
    strongCarouselText: '#1d1d1f',

    softBorder: '#e6e5e3',

    listItemBackground: '#f2f2f2',
    listItemNestedBackground: '#ffffff',

    imagePlaceholderBackground: '#ededed',
    imagePlaceholderIcon: '#d5d5d5',

    containerBackground: '#f8f8f8',
    fieldBorder: '#bdbdbd',

    /* Graphs */
    graphFontColorVariant1: '#111111',
    graphFontColorVariant2: '#232323',
    graphColorVariant1: '#35c8bf',
    graphColorVariant2: '#42f6a0',
    graphColorVariant3: '#7e7e7f',
    graphColorVariant4: '#d3d3d3',
    graphColorVariant5: '#2f4bf1',
    graphColorVariant6: '#42b4f4',
    graphColorVariant7: '#43e7f4',
    graphColorVariant8: '#e5346b',

    graphUserTotalColor: '#8884d8',
    graphUserActiveColor: '#83a6ed',
    graphUserAcceptedColor: '#8dd1e1',
    graphUserBookedColor: '#82ca9d',

    graphMeetingsCreatedColor: '#2F4BF1',
    graphMeetingsInquiredColor: '#41B4F3',
    graphMeetingsAcceptedColor: '#42F69F',
    graphMeetingsBookedColor: '#8884D8',
    graphMeetingsCancelledColor: '#E5346B',

    graphTotalInquiry: '#5ec77b',
    graphTotalContract: '#08c6bd',

    /* Preference Pills */
    preferredVenue: '#2f4bf2',
    preferredRank10: '#0582ee',
    preferredRank20: '#b5d0da',
    preferredRank30: '#f8c50a',
    preferredRank40: '#bfbfbf',
    preferredRank50: '#ad843c',

    /* neutrals */
    black: '#04080B',
    darkestGrey: '#303030',
    darkerGrey: '#4a4a4a',
    grey2: '#828282',
    darkGrey: '#909090',
    grey: '#c7c6c5',
    grey3: '#ACACAC',
    lightGrey: '#e6e5e3',
    lighterGrey: '#E0E0E0',

    /* pures */
    pureWhite: '#ffffff',
    pureBlack: '#000000',

    /* Theme colors */
    pink: '#e935a1',

    /* Carbon */
    carbonWhite: '#f6faf3',
    carbonGreen: '#49BBA0',

    /* Misc */
    blushPink: '#ff8bff',
    fuchsiaPink: '#CC60CC',
    greyBorder: '#DBDBDB',
    red: '#ff0000',
    green: '#008000',

    /* Redesign Palette */
    aliceBlue: '#E9F1FF',
    platinum: '#E1E1E2',
    vividFuchsia: '#AB36B8',
    drWhite: '#FAFAFA',
    coldWind: '#E1E3E5',

    /* Invoice Status */
    invoicePaid: '#17B26A',

    /* Bizly OS Colors - Need to take this out into it's own theme file */
    bizlyOSPrimary: '#5452F5',
    bizlyOSBorder: '#DBDBDB',
    bizlyOSYellow: '#FDE047',
    bizlyOSWarning: '#FFB61D',
    bizlyOSGray20: '#D6D6D5',

    /* Bizly OS "Claim your venue" modal */
    bizlyOSClaimPurple: '#310062',
    bizlyOSClaimTeal: '#00DAC5',
    bizlyOSClaimTint: '#EFE9F6',
    bizlyOSClaimSubtext: '#374151',
    bizlyOSClaimMuted: '#6B7280',
    bizlyOSClaimLine: '#E5E7EB',

    /* Bizly Insights */
    bizlyInsightsBlue: '#3478F7',
    bizlyInsightsButtonBlue: '#5452F5',

    /* Bizly OS Status Chips */
    lemonChiffon: '#FFF9C4',
    wizardWhite: '#E3F2FD',
    aquaSpring: '#E8F5E9',
    blushMist: '#FFEBEE',
    minuteMauve: '#F3E5F5',

    /* Bizly V3 UI colors TODO: move these colors to a new theme*/
    v3Background: '#F9F9F9',
    v3Background2: '#F3F3F3',
    v3Background3: '#F1F1F1',
    v3Border: '#E6E6E6',
    v3BorderSecondary: '#E2E2E2',
    v3Dark: '#121314',
    v3Red: '#E03131',
    v3Gray: '#DDDDDD',
    v3Success: '#2B8A3E',
    v3Error: '#EA4335',
    v3LightGrayBackground: '#F7F7F7',
    v3DarkGrayBorder: '#3F3F3F',
    v3TextPrimary: '#121314',
    v3TextSecondary: '#5E5E5E',
    v3TextPrimary2: '#2F2F2F',
    v3TextSecondary2: '#5A5A5A',
    v3ButtonPrimary: '#171717',
    v3Green: '#29733D',
    v3ButtonBackground: '#F2F2F2',
    v3CardBorder: '#E9E9E9',
    v3ChatInboundBubble: '#F1F3F5',
    v3OutgoingBubble: '#1A1A1A',
    v3StatusChipGreen: '#29733D',
    v3ContentText: '#323232',
    v3InfoGreen: '#34A853',
    v3IconMuted: '#495057',

    /* Venue Type Colors */
    venueTypeHotelBackground: '#F1B6B1',
    venueTypeHotelText: '#EA4335',
    venueTypeRestaurantBackground: '#AAEEBC',
    venueTypeRestaurantText: '#29733D',
    v3AccentColor: '#C17926',
    v3ButtonHover: '#DFDFDF',
    v3ButtonPressed: '#CACACA',
    v3ButtonPressedBorder: '#6F6F6F',

    /* Guestroom Savings */
    v3SavingsPublicRate: '#C77F0A',
    v3SavingsNegotiatedRate: '#4254FB',

    /* Events Guest Stat Cards */
    invitedGuestStatCardBackground: '#F5F5F5',
    invitedGuestStatCardBorder: '#fff9ed',
    declinedGuestStatCardBackground: '#f7eae9',
    declinedGuestStatCardBorder: '#ffe6e4',
    attendingGuestStatCardBackground: '#e8eee9',
    attendingGuestStatCardBorder: '#d5eed9',
    roomsGuestStatCardBackground: '#e4ebf7',
    roomsGuestStatCardBorder: '#e6efff',
};
